import { useSyncExternalStore } from 'react';

export const ROUTES = ['tanaan', 'tulevat', 'kausi', 'liiga'] as const;
export type Route = (typeof ROUTES)[number];

export const DEFAULT_ROUTE: Route = 'tanaan';

const parseHash = (hash: string): Route => {
    const name = hash.replace(/^#\/?/, '');
    return (ROUTES as readonly string[]).includes(name) ? name as Route : DEFAULT_ROUTE;
};

const subscribe = (listener: () => void) => {
    window.addEventListener('hashchange', listener);
    return () => window.removeEventListener('hashchange', listener);
};

// The tab shown, from the URL hash (#tanaan, #tulevat, #kausi, #liiga). Plain
// hash links keep the browser's back button and shareable links working on any
// static host, and an empty or unknown hash means the landing tab.
export function useHashRoute(): Route {
    return useSyncExternalStore(subscribe, () => parseHash(window.location.hash), () => DEFAULT_ROUTE);
}
